module.exports = __webpack_public_path__ + "assets/media/evening.3157525d.mp3";